import React, { useEffect, useRef, useState } from "react";
import FadeIn from "react-fade-in/lib/FadeIn";
import {
  Button,
  Card,
  CardBody,
  CardTitle,
  Col,
  Form,
  FormGroup,
  Input,
  Label,
  Modal,
  ModalBody,
  ModalHeader,
  Row,
} from "reactstrap";

import * as loadingLeaveTap from "../../../../assets/lottieAnimation/loadingLeaveTap.json";
import axios from "axios";
import { GetCookieData, GetCookieToken } from "../../../Cookie/GetCookie";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import { ConvertDate } from "../../../Function/ConvertDate";
import Breadcrumb from "../../../../components/Common/Breadcrumb";
import Lottie from "react-lottie";
import * as loadingReport from "../../../../assets/lottieAnimation/loadingReport.json";
import ExcelExport from "../ExcelExport";
import { CheckPosition } from "../../../Function/CheckPosition";
import { CheckSubAdmin } from "../../../Function/CheckSubAdmin";
import { ChunkArray } from "../../../Function/ChunkArray";
import { useLocation, useNavigate } from "react-router-dom";
import SubMenuEntryWork from "../../SubMenuEntryWork";
import NewThaiDatePicker from "../../../../components/Common/NewThaiDatePicker";
import LoadingData from "../../../TESTPage/LoadingData";
import SelectOrg from "../../selectOrg/selectOrg";
import { FetchAxiosGet } from "../../../../api/axios";

const Menu1 = ({ userInfo }) => {
  const baseURL = process.env.REACT_APP_API_CORS;
  const token = GetCookieToken("userToken");
  const user = GetCookieData("userData");
  const userPosition = GetCookieData("userPosition");
  const user_id = user?.user_id;
  const navigate = useNavigate();
  const pdfRef = useRef();

  const location = useLocation();

  const [showReport, setShowReport] = useState(false);
  const [employee, setEmployee] = useState([]);
  const [employeeAll, setEmployeeAll] = useState();
  const [orgInnerKong, setOrgInnerKong] = useState([]);
  const [orgInnerGroup, setOrgInnerGroup] = useState([]);
  const [thPlusTd, setThPlusTd] = useState([]);
  const [chunkThTd, setChunkThTd] = useState();
  const [chunkThTdPage, setChunkThTdPage] = useState();
  const [outData, setOutData] = useState([]);
  const [dataAllKong, setDataAllKong] = useState([]);
  const [leaveBefore, setLeaveBefore] = useState([]);
  const [positionFromInfo, setPositionFromInfo] = useState([]);
  const [subAdminFromInfo, setSubAdminFromInfo] = useState([]);
  const [loadingRep, setLoadingRep] = useState();
  const [loading, setLoading] = useState(false);
  const [modal, setModal] = useState(false);
  const [loadingReports, setLoadingReports] = useState(false);
  const [searchKong, setSearchKong] = useState(false);
  const [searchData, setSearchData] = useState({
    dmy_start: null,
    dmy_end: null,
    org_id_lv_2: "",
    org_id_lv_3: "",
    user_id: "",
    fileType: "1",
    reportType: "1",
  });

  ///////////////////////////// เข้าถึง Position และ SubAdmin
  useEffect(() => {
    // if (userInfo) {
      if (
        !CheckPosition(userPosition) &&
        !CheckSubAdmin(user?.positionSubAdmin)
      ) 
      {
        navigate("/entrywork");
      }
      setPositionFromInfo(userInfo?.position);
      setSubAdminFromInfo(userInfo?.positionSubAdmin);
    // }
  }, [user]);

  /////////////// ใช้แบ่ง array เป็น array ซ้อนที่มีขนาดตามต้องการ
  const chunkArray = (arr, size) => {
    return Array?.from({ length: Math?.ceil(arr?.length / size) }, (v, i) =>
      arr?.slice(i * size, i * size + size)
    );
  };

  /////////////// ใช้หาความยาว array เป็น array ของการแบ่ง
  const getLengthChunkArray = (arr, size) => {
    return Array?.from({ length: Math?.ceil(arr?.length / size) }, (v, i) =>
      arr?.slice(i * size, i * size + size)
    ).length;
  };

  /////////////////// รับกองเข้า Input
  const getOrgInnerKong = async () => {
    setOrgInnerKong([]);
    setOrgInnerGroup([]);
    try {
      if (subAdminFromInfo && subAdminFromInfo?.length !== 0) {
        const res = await axios.get(baseURL + `/api/orgInner/level`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
        (await res?.data?.result?.child) &&
          (await res?.data?.result?.child?.map((item) => {
            if (item?.active === 1) {
              setOrgInnerKong((prev) => [...prev, item]);
            }
          }));
      } else {
        if (positionFromInfo?.length !== 0) {
          positionFromInfo &&
            positionFromInfo?.map(async (item) => {
              if (item?.position_id === 5) {
                const res = await axios.get(baseURL + `/api/orgInner/level`, {
                  headers: {
                    Authorization: `Bearer ${token}`,
                  },
                });
                (await res?.data?.result?.child) &&
                  (await res?.data?.result?.child?.map((item2) => {
                    if (item2?.active === 1 && item?.org_id === item2?.org_id) {
                      setOrgInnerKong((prev) => [...prev, item2]);
                    }
                  }));
              } else if (item?.position_id === 7) {
                const res = await axios.get(
                  baseURL + `/api/orgInner/id/${item?.org_id}`,
                  {
                    headers: {
                      Authorization: `Bearer ${token}`,
                    },
                  }
                );
                setOrgInnerGroup((prev) => [...prev, res.data.result]);
              }
            });
        }
      }
    } catch (err) {
      console.error(err);
    }
  };

  /////////////////// รับ Employee เข้า Input
  const getEmployee = async () => {
    try {
      if (subAdminFromInfo?.length !== 0) {
        const url = baseURL + "/api/users/datatable";
        const params = new URLSearchParams({
          page: 1,
          size: 1000,
          "order[0]": "user_name",
          "order[1]": "DESC",
          "filter[user_name_status][0]": "ปกติ",
        });
        const config = {
          headers: {
            Authorization: `Bearer ${token}`,
          },
          params,
        };
        const res = await axios.get(url, config);
        setEmployee(res?.data?.result);
      } else if (subAdminFromInfo?.length === 0) {
        if (positionFromInfo?.length === 0) {
          const url = baseURL + "/api/users/datatable";
          const params = new URLSearchParams({
            page: 1,
            size: 1000,
            "order[0]": "user_name",
            "order[1]": "DESC",
            "filter[user_name_status][0]": "ปกติ",
            "filter[user_id][0]": user_id,
          });
          const config = {
            headers: {
              Authorization: `Bearer ${token}`,
            },
            params,
          };
          const res = await axios.get(url, config);
          setEmployee(res?.data?.result);
        } else {
          positionFromInfo &&
            positionFromInfo?.map(async (item) => {
              if (item?.position_id === 7) {
                const url = baseURL + "/api/users/datatable";
                const params = new URLSearchParams({
                  page: 1,
                  size: 1000,
                  "order[0]": "user_name",
                  "order[1]": "DESC",
                  "filter[user_name_status][0]": "ปกติ",
                  "filter[cont_to_id][0]": item?.org_id,
                });
                const config = {
                  headers: {
                    Authorization: `Bearer ${token}`,
                  },
                  params,
                };
                const res = await axios.get(url, config);
                setEmployee(res?.data?.result);
              }
            });
        }
      }
    } catch (err) {
      console.error(err);
    }
  };

  ////////////////// เรียกใช้งาน API ของข้อมูลเจ้าหน้าที่และสำนักกองใน Input Select
  useEffect(() => {
    if (userInfo) {
      getEmployee();
      getOrgInnerKong();
    }
  }, [positionFromInfo, subAdminFromInfo]);

  useEffect(() => {
    if (
      !subAdminFromInfo &&
      subAdminFromInfo?.length === 0 &&
      !positionFromInfo &&
      positionFromInfo.length === 0
    ) {
      setSearchData((prev) => ({ ...prev, user_id: employee[0].user_id }));
    } else if (
      subAdminFromInfo?.length === 0 &&
      orgInnerKong?.length === 0 &&
      orgInnerGroup?.length !== 0
    ) {
    } else if (
      subAdminFromInfo?.length === 0 &&
      orgInnerKong?.length !== 0 &&
      orgInnerGroup?.length !== 0
    ) {
    }
  }, [employee]);

  useEffect(() => {
    if (orgInnerKong?.length !== 0 && subAdminFromInfo?.length === 0) {
      setSearchData((prev) => ({
        ...prev,
        org_id_lv_2: orgInnerKong[0].org_id,
        org_id_lv_3: "",
      }));
      findByOrgKong(orgInnerKong[0]?.org_id);
      findEmployeeOfKong(orgInnerKong[0].org_id);
    }
  }, [orgInnerKong]);

  useEffect(() => {
    if (
      subAdminFromInfo?.length === 0 &&
      orgInnerKong?.length === 0 &&
      orgInnerGroup?.length !== 0
    ) {
      setSearchData((prev) => ({
        ...prev,
        org_id_lv_3: orgInnerGroup[0]?.org_id,
      }));
    }
  }, [orgInnerGroup]);

  const toggle = () => {
    if (modal === true) {
      setModal(!modal);
    } else {
      setModal(!modal);
    }
  };

  const findByOrgKong = async (id) => {
    setOrgInnerGroup([])
    orgInnerKong &&
      orgInnerKong?.map(async (item) => {
        // console.log(item.org_id , parseInt(id))
        if (item.org_id === parseInt(id)) {
          // setOrgInnerGroup((prev) => [...prev, item]);
          item?.child &&
            item?.child?.map((item) => {
              if (item?.active === 1){
                  setOrgInnerGroup((prev) => [...prev, item]);
                }
            });
        }
      });
  };

  const findByOrgGroup = (id) => {
    // setOrgInnerGroup(orgInnerGroup?.find((item) => item?.org_id === parseInt(id)))
  };

  const findEmployeeOfKong = async (id) => {
    if (id) {
      let ArrayGroupId =
        orgInnerKong.find((item) => item.org_id === parseInt(id))?.child
          ?.length === 0
          ? id
          : orgInnerKong.find((item) => item.org_id === parseInt(id))?.child;
      if (Array.isArray(ArrayGroupId)) {
        ArrayGroupId &&
          ArrayGroupId?.map(async (item) => {
            getEmployeeByKongID(item?.org_id);
          });
      } else {
      }
    } 
  };

  const findEmployeeOfGroup = async (id) => {
    if (id) {
      await setEmployee([]);
      await getEmployeeByGroupID(id);
    } 
  };
  const [loadingPDF, setLoadingPDF] = useState(false)
  const downloadPDF = async () => {
    setLoadingPDF(true)
    const pdf = new jsPDF("l", "mm", "a4", true); //แนวนอน
    // const pdf = new jsPDF("", "mm", "a4", true); //แนวตั้ง
    const input = pdfRef.current;
    // let maxLoop = await input.childNodes.length;

    for (let i = 0; i < chunkThTdPage; i++) {
      const element = input.childNodes[i];
      const canvass = await html2canvas(element, { scale: 2 });
      // let imgWidth = 400;
      // let imgHeight = (canvass.height * imgWidth) / canvass.width;
      const imgWidth = canvass.width;
      const imgHeight = canvass.height;
      const imgData = canvass.toDataURL("image/png");
      const pdfWidth = pdf.internal.pageSize.getWidth();
      const pdfHeight = pdf.internal.pageSize.getHeight();
      const ratio = Math.min(pdfWidth / imgWidth, pdfHeight / imgHeight);
      const imgX = (pdfWidth - imgWidth * ratio) / 2;
      const imgY = 5;

      if (i > 0) {
        pdf.addPage();
      }

      pdf.addImage(
        imgData,
        "PNG",
        imgX,
        imgY,
        imgWidth * ratio,
        imgHeight * ratio
      );
    }

    await pdf.save(selectFileNameByType(searchData?.reportType));
    setTimeout(() => {
      setLoadingPDF(false)
    }, 1000);
  };

  const getEmployeeByKongID = async (ArrayGroupId) => {
    try {
      const url = baseURL + "/api/users/datatable";
      const params = new URLSearchParams({
        page: 1,
        size: 100,
        "order[0]": "created_date",
        "order[1]": "DESC",
        "filter[user_id_status][0]": "1",
        "filter[cont_to_id][0]": ArrayGroupId,
      });
      const config = {
        headers: {
          Authorization: `Bearer ${token}`,
        },
        params,
      };
      const res = await axios.get(url, config);
      res?.data?.result &&
        res?.data?.result?.map(async (item) => {
          setEmployee((prev) => [...prev?.filter(x => x.user_id !== item.user_id), item]);
        });
    } catch (err) {
      console.error(err);
    }
  };
  const getEmployeeByGroupID = async (ArrayGroupId) => {
    try {
      const url = baseURL + "/api/users/datatable";
      const params = new URLSearchParams({
        page: 1,
        size: 100,
        "order[0]": "created_date",
        "order[1]": "DESC",
        "filter[user_name_status][0]": "ปกติ",
        "filter[cont_to_id][0]": ArrayGroupId,
      });
      const config = {
        headers: {
          Authorization: `Bearer ${token}`,
        },
        params,
      };
      const res = await axios.get(url, config);
      (await res?.data?.result) &&
        (await res?.data?.result?.map((item) => {
          setEmployee((prev) => [...prev?.filter(x => x.user_id !== item.user_id), item]);
        }));
    } catch (err) {
      console.error(err);
    }
  };

  const getSearchEntry = async (page) => {
    setLoadingRep(false);
    setDataAllKong([]);
    setThPlusTd([]);
    setChunkThTd();
    setChunkThTdPage();
    setOutData([]);
    try {
      const url = `${baseURL}/api/time/history`;
      if (
        ////////////// หาข้อมูลโดยที่ไม่มี filter อะไรเลย
        !searchData?.org_id_lv_2 &&
        !searchData?.org_id_lv_3 &&
        !searchData?.user_id
      ) {
        const params = new URLSearchParams({
          page: 1,
          size: 10000,
          "order[0]": "user_id",
          "order[1]": "ASC",
          date_start: ConvertDate(searchData?.dmy_start).toOnlyDate(),
          date_end: ConvertDate(searchData?.dmy_end).toOnlyDate(),
        });
        const config = {
          headers: {
            Authorization: `Bearer ${token}`,
          },
          params,
        };
        const res = await axios.get(url, config);
        setDataAllKong(res?.data?.result);
        setLoadingRep(true);
        toggle();
        
      } else if (
        ///////////// หาข้อมูลที่ filter เฉพาะ กอง
        searchData?.org_id_lv_2 &&
        !searchData?.org_id_lv_3 &&
        !searchData?.user_id
      ) {
        orgInnerGroup?.map(async (item) => {
          const params = new URLSearchParams({
            page: 1,
            size: 10000,
            "order[0]": "user_id",
            "order[1]": "ASC",
            "filter[cont_to_id][0]": item?.org_id,
            date_start: ConvertDate(searchData?.dmy_start)?.toOnlyDate(),
            date_end: ConvertDate(searchData?.dmy_end)?.toOnlyDate(),
          });
          const config = {
            headers: {
              Authorization: `Bearer ${token}`,
            },
            params,
          };
          const res = await axios.get(url, config);
          let newData = {
            org_id: item?.org_id,
            org_name: item?.org_name,
            groupData: res?.data?.result?.sort(
              (a, b) => new Date(a?.date) - new Date(b?.date)
            ),
          };
          setDataAllKong((prev) => [...prev, newData]);
          setSearchKong(true)
          setLoadingRep(true);
          toggle();
        });
      } else if (
        /////////////// หาข้อมูลที่ filter เฉพาะคนภายในกลุ่มนั้นๆ
        (searchData?.org_id_lv_2 &&
          searchData?.org_id_lv_3 &&
          !searchData?.user_id) ||
        (!searchData?.org_id_lv_2 &&
          searchData?.org_id_lv_3 &&
          !searchData?.user_id)
      ) {
        ///call กอง และ กลุ่ม
        let kongId = orgInnerGroup?.find(
          (a) => Number(a?.org_id) === Number(searchData?.org_id_lv_3)
        )?.parent_id;
        let kongName = "";
        try {
          const res = await axios.get(baseURL + `/api/orgInner/id/${kongId}`, {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          });
          kongName = res?.data?.result?.org_name;
        } catch (err) {
          console.error(err);
        }
        let groupName = orgInnerGroup?.find(
          (a) => Number(a?.org_id) === Number(searchData?.org_id_lv_3)
        )?.org_name;
        setThPlusTd((prev) => [
          ...prev,
          { kongName: kongName, groupName: groupName },
        ]);
        const params = new URLSearchParams({
          page: 1,
          size: 10000,
          "order[0]": "user_id",
          "order[1]": "ASC",
          "filter[cont_to_id][0]": searchData?.org_id_lv_3,
          date_start: ConvertDate(searchData?.dmy_start)?.toOnlyDate(),
          date_end: ConvertDate(searchData?.dmy_end)?.toOnlyDate(),
        });
        const config = {
          headers: {
            Authorization: `Bearer ${token}`,
          },
          params,
        };
        const res = await axios.get(url, config);
        setDataAllKong(res?.data?.result);
        setLoadingRep(true);
        setSearchKong(false)
        toggle();
      } else if (
        ////////////// ค้นหาตามรายบุคคล
        (searchData?.org_id_lv_2 &&
          searchData?.org_id_lv_3 &&
          searchData?.user_id) ||
        (searchData?.org_id_lv_2 &&
          !searchData?.org_id_lv_3 &&
          searchData?.user_id) ||
          (!searchData?.org_id_lv_2 &&
            searchData?.org_id_lv_3 &&
            searchData?.user_id)
      ) {
        const params = new URLSearchParams({
          page: 1,
          size: 10000,
          "order[0]": "user_id",
          "order[1]": "ASC",
          "filter[user_id][0]": searchData?.user_id,
          date_start: ConvertDate(searchData?.dmy_start)?.toOnlyDate(),
          date_end: ConvertDate(searchData?.dmy_end)?.toOnlyDate(),
        });
        const config = {
          headers: {
            Authorization: `Bearer ${token}`,
          },
          params,
        };
        const res = await axios.get(url, config);
        setDataAllKong(res?.data?.result);
        setLoadingRep(true);
        // await setLoadingRep(true);
        toggle();
      } else if (
        (!searchData?.org_id_lv_2 &&
        !searchData?.org_id_lv_3 &&
        searchData?.user_id)){
          const params = new URLSearchParams({
            page: 1,
            size: 10000,
            "order[0]": "user_id",
            "order[1]": "ASC",
            "filter[user_id][0]": searchData?.user_id,
            date_start: ConvertDate(searchData?.dmy_start)?.toOnlyDate(),
            date_end: ConvertDate(searchData?.dmy_end)?.toOnlyDate(),
          });
          const config = {
            headers: {
              Authorization: `Bearer ${token}`,
            },
            params,
          };
          const res = await axios.get(url, config);
          setDataAllKong(res?.data?.result);
          setLoadingRep(true);
          setSearchKong(false)
          // await setLoadingRep(true);
          toggle();
      }
      // setLoading(true);
    } catch (err) {
      console.error(err);
    }
  };

  useEffect(() => {
    setOutData([]);
    if (
      (searchData?.org_id_lv_2 &&
        searchData?.org_id_lv_3 &&
        !searchData?.user_id) ||
      (!searchData?.org_id_lv_2 &&
        searchData?.org_id_lv_3 &&
        !searchData?.user_id) 
    ) {
      dataAllKong.sort((a, b) => {
        // if (a.user_id !== b.user_id) {
        //   return a.user_id - b.user_id;
        // }
        return new Date(a?.date) - new Date(b?.date);
      });
    } else if (
      searchData?.org_id_lv_2 &&
      !searchData?.org_id_lv_3 &&
      !searchData?.user_id
    ) {
      dataAllKong.sort((a, b) => {
        if (a.user_id !== b.user_id) {
          return a.user_id - b.user_id;
        }
        return new Date(a?.date) - new Date(b?.date);
      });
    }
    // if (searchData?.org_id_lv_2 && searchData?.org_id_lv_3) {
    //   dataAllKong.sort((a, b) => {
    //     if (a.user_id !== b.user_id) {
    //       return a.user_id - b.user_id;
    //     }
    //     return new Date(a?.date) - new Date(b?.date);
    //   });
    // }
    // if (searchData?.org_id_lv_2 && !searchData?.org_id_lv_3) {
    //   dataAllKong.sort((a, b) => a.org_id - b.org_id);
    // }
  }, [dataAllKong]);

  useEffect(() => { //ส่วนของการ set ข้อมูลออกไปแสดง
    setOutData([]);
    let result = [];

    dataAllKong &&
      dataAllKong?.map((item, idx) => {
        // result.push(item?.date)
        if (Number(idx) === 0) {
          result.push(item?.date);
        } else if (result?.find((a) => a !== item?.date)) {
          result.push(item?.date);
        } else {
        }
      });
    let arr = []
    setLoadingReports(true)
    if (dataAllKong?.length > 0 ) {
      dataAllKong?.map((item) => {
        if (searchData?.reportType === "2") {
          if (item?.groupData && item?.groupData.length !== 0) {
            if (
              item?.groupData?.find((item) => item?.entry_exit_status === 0)
            ) {
              setThPlusTd((prev) => [...prev, item]);
              item?.groupData &&
                item?.groupData?.map((item2) => {
                  if (item2?.entry_exit_status === 0)
                    setThPlusTd((prev) => [...prev, item2]);
                  else if (item2?.entry_exit_status === 1)
                    setOutData((prev) => [...prev, item2]);
                });
            }
          }
        }
        if (searchData?.reportType === "4") {
          if (item?.groupData && item?.groupData.length !== 0) {
            // if (item?.groupData?.find((item) => item?.entry_exit_status !== 1))
            setThPlusTd((prev) => [...prev, item]);
            item?.groupData &&
              item?.groupData?.map((item2) => {
                if (item2?.entry_exit_status === 0)
                  setThPlusTd((prev) => [...prev, item2]);
                else if (item2?.entry_exit_status === 1)
                  setOutData((prev) => [...prev, item2]);
              });
          }
        }
        if (searchData?.reportType === "5") {
          if (item?.groupData && item?.groupData.length !== 0) {
            if (
              item?.groupData?.find(
                (item) =>
                  (item?.entry_exit_status !== 3 &&
                    item?.entry_exit_status !== 1 &&
                    item?.entry_exit_status !== 0) ||
                  (item?.entry_exit_status === 0 && item?.workingours < 8)
              )
            )
              setThPlusTd((prev) => [...prev, item]);
            item?.groupData &&
              item?.groupData?.map((item2) => {
                if (
                  (item2?.entry_exit_status !== 3 &&
                    item2?.entry_exit_status !== 1 &&
                    item2?.entry_exit_status !== 0) ||
                  (item2?.entry_exit_status === 0 && item2?.workingours < 8)
                )
                  setThPlusTd((prev) => [...prev, item2]);
                else if (item2?.entry_exit_status === 1)
                  setOutData((prev) => [...prev, item2]);
              });
          }
        }
      })
    } 
    setTimeout(() => {
      setLoadingReports(false)
    }, 1000);

  }, [dataAllKong]);

  const removeDuplicates = (data) => {
    const groupedData = [];
    let currentGroup = null;
    
    data.forEach(item => {
        if (item.org_id && item.org_name) {
            currentGroup = { org_id: item.org_id, org_name: item.org_name, groupData: [] };
            groupedData.push(currentGroup);
        } else if (currentGroup) {
            currentGroup.groupData.push(item);
        }
    });

    const uniqueData = groupedData.reduce((acc, current) => {
    const x = acc.find(item => item.org_id === current.org_id);
        if (!x) {
          return acc.concat([current]);
        } else {
          return acc;
        }
    }, []);

    const restructuredData = uniqueData.flatMap(org => {
    const { org_id, org_name, groupData } = org;
        return [
            { org_id, org_name, groupData },
            ...groupData?.map(item => ({ ...item }))
        ];
    });
    // console.log(restructuredData, uniqueData, groupedData, data)
    return restructuredData
  };


  

  useEffect(() => {
    if (searchKong) {
      setChunkThTd(ChunkArray(removeDuplicates(thPlusTd), 19));
      setChunkThTdPage(ChunkArray(removeDuplicates(thPlusTd), 19)?.length);
    } else {
      setChunkThTd(ChunkArray(thPlusTd, 19));
      setChunkThTdPage(ChunkArray(thPlusTd, 19)?.length);
    }
  }, [thPlusTd]);

  const getLeaveBeforeTime = async () => {
    try {
      setLeaveBefore([]);
      setChunkThTd([]);
      setChunkThTdPage([]);
      const url = baseURL + `/api/leave/datatable`;
      // employee?.map(async (item) => {
      const params = new URLSearchParams({
        page: 1,
        size: 10000,
        "order[0]": "created_date",
        "order[1]": "DESC",
        "filter[leave_type_id][0]": 16,
      });
      const config = {
        headers: {
          Authorization: `Bearer ${token}`,
        },
        params,
      };
      const res = await axios.get(url, config);
      setLeaveBefore(res?.data?.result);
      toggle();
    } catch (err) {
      console.error(err);
    }
  };
  
  useEffect(() => {
    leaveBefore?.sort((a, b) => {
      if (a?.user_id !== b?.user_id) {
        return parseInt(a?.user_id) - parseInt(b?.user_id);
      }
      return new Date(a?.write_date) - new Date(b?.write_date);
    });
    setChunkThTd(chunkArray(leaveBefore, 19));
    setChunkThTdPage(getLengthChunkArray(leaveBefore, 19));
    setLoadingRep(true);
  }, [leaveBefore]);

  //////////////////////// Reset การ Search
  const handleResetSearch = () => {
    setLoading(true)
    setSearchData((prev) => ({
      ...prev,
      dmy_start: null,
      dmy_end: null,
      org_id_lv_2: "",
      org_id_lv_3: "",
      user_id: "",
      fileType: "1",
      reportType: "1",
    }));

    setShowReport(false);
    setOrgInnerGroup([]);
    // getEmployee();

    const pdfRadio = document.querySelector(
      'input[name="typeFile"][value="1"]'
    );
    const csvRadio = document.querySelector(
      'input[name="typeFile"][value="2"]'
    );
    const reportType1 = document.querySelector(
      'input[name="typeReport"][value="1"]'
    );
    const reportType2 = document.querySelector(
      'input[name="typeReport"][value="2"]'
    );
    const reportType3 = document.querySelector(
      'input[name="typeReport"][value="3"]'
    );
    const reportType4 = document.querySelector(
      'input[name="typeReport"][value="4"]'
    );

    if (pdfRadio && csvRadio) {
      pdfRadio.checked = true;
      csvRadio.checked = false;
    }

    if (reportType1 && reportType2 && reportType3 && reportType4) {
      reportType1.checked = true;
      reportType2.checked = false;
      reportType3.checked = false;
      reportType4.checked = false;
    }
    setTimeout(() => {
      setLoading(false)
    }, 1500);
  };

  const selectFileNameByType = (reportType) => {
    return reportType === "1" ? "รายงานการลงเวลาปฎิบัติงาน"
            : reportType === "2" ? "รายงานการเข้างานสาย"
            : reportType === "4" ? "รายงานการทำงานล่วงเวลา"
            : reportType === "5" ? "รายงานไม่ครบตามรอบเวลา"
            : reportType === "6" ? "รายงานขออนุญาตกลับก่อน"
            : "ไฟล์ไม่ทราบชื่อ"
  }

  const setDateStart = (e) => {
    setSearchData((prev) => ({
      ...prev,
      dmy_start: e,
    }));
  }

  const setDateEnd = (e) => {
    setSearchData((prev) => ({
      ...prev,
      dmy_end: e,
    }));
  }

  const [windowSize, setWindowSize] = useState({
    width: window.innerWidth,
    height: window.innerHeight
  });

  useEffect(() => {
    const handleResize = () => {
      setWindowSize({
        width: window.innerWidth,
        height: window.innerHeight
      });
    };

    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  const setDivisionOrgObj = (event, allUser) =>{
    if (allUser !== undefined) {
      setEmployeeAll(allUser)
    }
    if (event === "") {
      setSearchData((prev) => ({
        ...prev,
        org_id_lv_2: event,
        org_id_lv_3: event,
        user_id: event,
      }));
    } else {
      setSearchData((prev) => ({
        ...prev,
        org_id_lv_2: event,
      }));
    }
    
  }

  const setGroupOrgObj = (event) =>{
    if (event === searchData?.org_id_lv_2) {
      setSearchData((prev) => ({
        ...prev,
        org_id_lv_3: "",
        user_id: "",
      }));
    } else {
      setSearchData((prev) => ({
        ...prev,
          org_id_lv_3: event,
      }));
    }
  
  }

  const setUserOrgObj = (event) =>{
    setSearchData((prev) => ({
      ...prev,
      user_id: event,
    }));
  }

  const needAllUser = (event) =>{
    setEmployeeAll(event)
  }

  
  // ทำ delay ปุ่ม และตอนสลับ select ให้ disble ปุ่มค้นหาไว้แปปนึง เพราะข้อมูลโหลดไม่ทัน  

  const getSearchEntryNew = async () =>{
    setLoadingRep(false);
    setDataAllKong([]);
    setThPlusTd([]);
    setChunkThTd();
    setChunkThTdPage();
    setOutData([]);
    const url = '/api/time/history';

    let params = new URLSearchParams({
        page: 1,
        size: 10000,
        "order[0]": "user_id",
        "order[1]": "ASC",
        date_start: ConvertDate(searchData?.dmy_start).toOnlyDate(),
        date_end: ConvertDate(searchData?.dmy_end).toOnlyDate(),
        for_report: 1
      }); 
    if (searchData?.org_id_lv_2 === "" && searchData?.org_id_lv_3 === "" && searchData?.user_id === "") {
      //จะดึงข้อมูลทั้งหมด
    } else if (searchData?.user_id !== "") {
      params.append("filter[user_id][0]",searchData?.user_id)
    } else if (searchData?.org_id_lv_3 !== "") {
      params.append("filter[cont_to_id][0]",searchData?.org_id_lv_3)
    } else if (searchData?.org_id_lv_2 !== "") {
      if (orgInnerKong.find( y => y.org_id == searchData?.org_id_lv_2)?.child.length > 0) {
        for (let index = 0; index < orgInnerKong.find( y => y.org_id == searchData?.org_id_lv_2)?.child.length; index++) {
          const element = orgInnerKong.find( y => y.org_id == searchData?.org_id_lv_2)?.child[index];
          params.append(`filter[cont_to_id][${index}]`, element?.org_id)
        }
      } else {
        params.append("filter[cont_to_id][0]",searchData?.org_id_lv_2)
      }
    }
    const res = await FetchAxiosGet(url, token, params)
    
    let arr = []
    let arrRangedate = []
    let arrRangedateUser = []

    let dateStart = new Date(searchData?.dmy_start).setHours(0, 0, 0, 0);
    let dateEnd = new Date(searchData?.dmy_end).setHours(0, 0, 0, 0);
    let currentDate = new Date().setHours(0, 0, 0, 0);

    if (searchData?.org_id_lv_2 === "" && searchData?.org_id_lv_3 === "" && searchData?.user_id === "") {
      if (!(currentDate == dateStart && currentDate == dateEnd)) {
        for (let index = 0; index < orgInnerKong.length; index++) {
          const element = orgInnerKong[index];
          if (element?.child?.length > 0) {
            for (let index = 0; index < element?.child?.length; index++) {
              const elementChild = element?.child[index];
              if (employeeAll?.filter(filEm => filEm.cont_to_id ==  elementChild?.org_id)?.length > 0) {
                  arr.push({kongName: element?.org_name, groupName: elementChild?.org_name, orgID: elementChild?.org_id})
              }
            }  
          } else {
            if (employeeAll?.filter(filEm => filEm.cont_to_id ==  element?.org_id)?.length > 0) {
              arr.push({kongName: element?.org_name, groupName: element?.org_name, orgID: element?.org_id})
            }
          }
        }
      }
    } else if (searchData?.user_id !== "") {
      arrRangedateUser.push(
        {
          kongName: orgInnerKong.find( y => y.org_id == searchData?.org_id_lv_2)?.org_name, 
          groupName: orgInnerKong.find( y => y.org_id == searchData?.org_id_lv_2)?.child?.find( groupOrg => groupOrg.org_id == searchData?.org_id_lv_3)?.org_name
        }
      )
      // arrRangedateUser.push(employeeAll?.find( x => x.user_id == searchData?.user_id))
    } else if (searchData?.org_id_lv_3 !== "") {
      arrRangedate.push({
        kongName: orgInnerKong.find( y => y.org_id == searchData?.org_id_lv_2)?.org_name, 
        groupName: orgInnerKong.find( y => y.org_id == searchData?.org_id_lv_2)?.child?.find( groupOrg => groupOrg.org_id == searchData?.org_id_lv_3)?.org_name
      })
      if ((currentDate == dateStart && currentDate == dateEnd) || (currentDate >= dateStart && currentDate <= dateEnd)) {
        for (let index = 0; index < employeeAll.length; index++) {
          const element = employeeAll[index];
          arrRangedate.push(element)
        }
      }
    } else if (searchData?.org_id_lv_2 !== "") {
      if ((currentDate == dateStart && currentDate == dateEnd) || (currentDate >= dateStart && currentDate <= dateEnd)) {
        if (orgInnerKong.find( y => y.org_id == searchData?.org_id_lv_2)?.child.length > 0) {
          for (let index = 0; index < orgInnerKong.find( y => y.org_id == searchData?.org_id_lv_2)?.child.length; index++) {
            const element = orgInnerKong.find( y => y.org_id == searchData?.org_id_lv_2)?.child[index];
            if (employeeAll?.filter(filEm => filEm.cont_to_id ==  element?.org_id)?.length > 0) {
              arr.push({kongName: orgInnerKong.find( y => y.org_id == searchData?.org_id_lv_2)?.org_name, groupName: element?.org_name, orgID: element?.org_id})
              arr.push(employeeAll?.filter(filEm => filEm.cont_to_id ==  element?.org_id))
              arr = arr?.flat()
            }
          }
        } else {
            arr.push({kongName: orgInnerKong.find( y => y.org_id == searchData?.org_id_lv_2)?.org_name, groupName: "", orgID: orgInnerKong.find( y => y.org_id == searchData?.org_id_lv_2)?.org_id})
            arr.push(employeeAll?.filter(filEm => filEm.cont_to_id ==  orgInnerKong.find( y => y.org_id == searchData?.org_id_lv_2)?.org_id))
            arr = arr?.flat()
        }
      } else {
        for (let index = 0; index < orgInnerKong.find( y => y.org_id == searchData?.org_id_lv_2)?.child.length; index++) {
          const element = orgInnerKong.find( y => y.org_id == searchData?.org_id_lv_2)?.child[index];
          if (employeeAll?.filter(filEm => filEm.cont_to_id ==  element?.org_id)?.length > 0) {
            arr.push({kongName: orgInnerKong.find( y => y.org_id == searchData?.org_id_lv_2)?.org_name, groupName: element?.org_name, orgID: element?.org_id})
          }
        }
      }
    }

    if (res?.result?.length > 0) {
      res?.result?.map(async (item,index) => {
          if (searchData?.org_id_lv_2 === "" && searchData?.org_id_lv_3 === "" && searchData?.user_id === "") {
            //จะดึงข้อมูลทั้งหมด
            if (currentDate == dateStart && currentDate == dateEnd) {
              orgInnerKong?.map(x => {
                if (x.child?.length > 0) {
                  x.child?.map(y =>{
                    let filTerGroup = employeeAll.filter(z => z.cont_to_id === y.org_id)
                    if (employeeAll.filter(z => z.cont_to_id === y.org_id).length > 0) {
                      arr.push({kongName: x.org_name, groupName: y.org_name})
                      arr.push(filTerGroup)
                    }
                  })
                } else {
                    let filTerGroup = employeeAll.filter(z => z.cont_to_id === x.org_id)
                    if (employeeAll.filter(z => z.cont_to_id === x.org_id).length > 0) {
                      arr.push({kongName: x.org_name, groupName: ""})
                      arr.push(filTerGroup)
                    }
                }
              })
              arr = arr.flat()
              if (item?.entry_exit_status !== 1){
                if (arr.findIndex( x => x.user_id == item.user_id) !== -1) {
                  arr[arr.findIndex( x => x.user_id == item.user_id)] = item
                }
    
                let seen = new Set();
                let uniqueArray = arr.filter((items, index) => {
                  let key = JSON.stringify(items); 
                  return seen.has(key) ? false : seen.add(key);
                });
    
                let seenUserIds = new Set();
                let uniqueData = uniqueArray.filter((itemz) => {
                  if (seenUserIds.has(itemz.user_id || itemz.kongName)) {
                      return false;
                  }  else {
                      seenUserIds.add(itemz.user_id);
                      return true;
                  }
                });
                setThPlusTd(uniqueData)
              } else if (item?.entry_exit_status === 1){
                  // if (arr.findIndex( x => x.user_id == item.user_id) !== -1) {
                  //   arr[arr.findIndex( x => x.user_id == item.user_id)] = item
                  // }
      
                  // let seen = new Set();
                  // let uniqueArray = arr.filter((items, index) => {
                  //   let key = JSON.stringify(items); 
                  //   return seen.has(key) ? false : seen.add(key);
                  // });
      
                  // let seenUserIds = new Set();
                  // let uniqueData = uniqueArray.filter((itemz) => {
                  //   if (seenUserIds.has(itemz.user_id || itemz.kongName)) {
                  //       return false;
                  //   }  else {
                  //       seenUserIds.add(itemz.user_id);
                  //       return true;
                  //   }
                  // });
                  // setOutData(uniqueData)
                  setOutData((prev) => [...prev, item]);
              }
            } else {
              if (item?.entry_exit_status !== 1){
                arr.push(item)

                let kongData = arr.filter(item => item.kongName);
                let userData = arr.filter(item => !item.kongName);

                userData.sort((a, b) => a.cont_to_id - b.cont_to_id);

                let sortedArr = [];

                kongData.forEach(kong => {
                  sortedArr.push(kong);
                  userData.forEach(user => {
                    if (user.cont_to_id === kong.orgID) {
                      sortedArr.push(user);
                    }
                  });
                });
                setThPlusTd(sortedArr)
              } else if (item?.entry_exit_status === 1){
                setOutData((prev) => [...prev, item]);
              }
            }

          } else if (searchData?.user_id !== "") {
            // if (currentDate >= dateStart && currentDate <= dateEnd) {
              if (item?.entry_exit_status !== 1){
                let all_org = []
                arrRangedateUser =  arrRangedateUser.splice(1, 1);
                // arrRangedateUser.splice(1, 1);
                for await (const i of orgInnerKong) {
                  if (i.child?.length > 0) {
                    i.child.map(y =>{
                      all_org.push(y)
                    })
                  } else {
                    all_org.push(i)
                  }
                }
                
                arrRangedateUser.push({
                  kongName: orgInnerKong.find( y => y.org_id == all_org.find( y => y.org_id == item?.cont_to_id)?.parent_id)?.org_name, 
                  groupName: all_org.find( y => y.org_id == item?.cont_to_id)?.org_name, 
                }) 

                arrRangedateUser.push(item) 
                // arrRangedateUser.sort((a, b) => {
                //   if (a.kongName) return -1;
                //   if (b.kongName) return 1;
                //   if (a.user_id !== b.user_id) return a.user_id - b.user_id;
                //   if (a.fscan_id && !b.fscan_id) return -1;
                //   if (!a.fscan_id && b.fscan_id) return 1;
                //   if (a.fscan_id && b.fscan_id) return a.fscan_id.localeCompare(b.fscan_id);
                //   return 0;
                // });
                setThPlusTd(arrRangedateUser)
              } else if (item?.entry_exit_status === 1){
                setOutData((prev) => [...prev, item]);
              }
            // } else {
              // // arrRangedateUser.splice(1, 1);
              // if (item?.entry_exit_status !== 1){
              //   arrRangedateUser.push(item)
              //   arrRangedateUser.sort((a, b) => {
              //     if (a.kongName) return -1;
              //     if (b.kongName) return 1;
              //     if (a.user_id !== b.user_id) return a.user_id - b.user_id;
              //     if (a.fscan_id && !b.fscan_id) return -1;
              //     if (!a.fscan_id && b.fscan_id) return 1;
              //     if (a.fscan_id && b.fscan_id) return a.fscan_id.localeCompare(b.fscan_id);
              //     return 0;
              //   });
              //   setThPlusTd(arrRangedateUser)
              // } else if (item?.entry_exit_status === 1){
              //   setOutData((prev) => [...prev, item]);
              // }
            // }
          } else if (searchData?.org_id_lv_3 !== "") {
            if (currentDate == dateStart && currentDate == dateEnd) {
              let emData
              let emAllSub = employeeAll
              if (item?.entry_exit_status !== 1){
                if (emAllSub.findIndex( x => x.user_id == item.user_id) !== -1) {
                  emAllSub[emAllSub.findIndex( x => x.user_id == item.user_id)] = item
                }
                emData = [{
                  kongName: orgInnerKong.find( y => y.org_id == searchData?.org_id_lv_2)?.org_name, 
                  groupName: orgInnerKong.find( y => y.org_id == searchData?.org_id_lv_2)?.child?.find( groupOrg => groupOrg.org_id == searchData?.org_id_lv_3)?.org_name
                }]
                emAllSub.forEach(element => { emData.push(element) });
                // setThPlusTd((prev) => [...prev, item])
                setThPlusTd(emData)
              } else if (item?.entry_exit_status === 1){
                setOutData((prev) => [...prev, item]);
              }
            } else if(currentDate >= dateStart && currentDate <= dateEnd) {
              
              if (item?.entry_exit_status !== 1){

                arrRangedate.push(item)
                arrRangedate = arrRangedate.flat()
                arrRangedate.sort((a, b) => {
                  if (a.kongName) return -1;
                  if (b.kongName) return 1;
                  if (a.user_id !== b.user_id) return a.user_id - b.user_id;
                  if (a.fscan_id && !b.fscan_id) return -1;
                  if (!a.fscan_id && b.fscan_id) return 1;
                  if (a.fscan_id && b.fscan_id) return a.fscan_id.localeCompare(b.fscan_id);
                  return 0;
                });
                setThPlusTd(arrRangedate)
              } else if (item?.entry_exit_status === 1){
                setOutData((prev) => [...prev, item]);
              }
            } else {
              if (item?.entry_exit_status !== 1){
                arrRangedate.push(item)
                arrRangedate = arrRangedate.flat()
                arrRangedate.sort((a, b) => {
                  if (a?.kongName) return -1;
                  if (b?.kongName) return 1;
                  if (a?.user_id !== b?.user_id) return a?.user_id - b?.user_id;
                  if (a?.fscan_id && !b?.fscan_id) return -1;
                  if (!a?.fscan_id && b?.fscan_id) return 1;
                  if (a?.fscan_id && b?.fscan_id) return a?.fscan_id?.localeCompare(b?.fscan_id);
                  return 0;
                });
                setThPlusTd(arrRangedate)
              } else if (item?.entry_exit_status === 1){
                setOutData((prev) => [...prev, item]);
              }
            }
          } else if (searchData?.org_id_lv_2 !== "") {
            if (currentDate == dateStart && currentDate == dateEnd) {
              if (item?.entry_exit_status !== 1){
                let emAllSub = employeeAll
                if (emAllSub.findIndex( x => x.user_id == item.user_id) !== -1) {
                  emAllSub[emAllSub.findIndex( x => x.user_id == item.user_id)] = item
                }
  
                // if (orgInnerKong.find( y => y.org_id == searchData?.org_id_lv_2)?.child.length > 0) {
                //   for (let index = 0; index < orgInnerKong.find( y => y.org_id == searchData?.org_id_lv_2)?.child.length; index++) {
                //     const element = orgInnerKong.find( y => y.org_id == searchData?.org_id_lv_2)?.child[index];
                //     if (emAllSub?.filter(filEm => filEm.cont_to_id ==  element?.org_id)?.length > 0) {
                //       arr.push({kongName: orgInnerKong.find( y => y.org_id == searchData?.org_id_lv_2)?.org_name, groupName: element?.org_name})
                //       arr.push(emAllSub?.filter(filEm => filEm.cont_to_id ==  element?.org_id))
                //       arr = arr?.flat()
                //     }
                //   }
                // } else {
                //     arr.push({kongName: orgInnerKong.find( y => y.org_id == searchData?.org_id_lv_2)?.org_name, groupName: ""})
                //     arr.push(emAllSub?.filter(filEm => filEm.cont_to_id ==  orgInnerKong.find( y => y.org_id == searchData?.org_id_lv_2)?.org_id))
                //     arr = arr?.flat()
                // }
  
                // let seen = new Set();
                // let uniqueArray = arr.filter((items, index) => {
                //   let key = JSON.stringify(items); 
                //   return seen.has(key) ? false : seen.add(key);
                // });
  
                let seen = new Map();
                let uniqueArray = arr.filter(item => {
                    let key = item.user_id || `${item.kongName}_${item.groupName}`;
                    if (seen.has(key)) {
                        return false;
                    } else {
                        seen.set(key, item);
                        return true;
                    }
                });
                uniqueArray = Array.from(seen.values());
                setThPlusTd(uniqueArray)
              } else if (item?.entry_exit_status === 1){
                setOutData((prev) => [...prev, item]);
              }
            } else if (currentDate >= dateStart && currentDate <= dateEnd) {
              if (item?.entry_exit_status !== 1){
                arr.push(item)
                arr.sort((a, b) => {
                  if (a.kongName) return -1;
                  if (b.kongName) return 1;
                  if (a.user_id !== b.user_id) return a.user_id - b.user_id;
                  if (a.fscan_id && !b.fscan_id) return -1;
                  if (!a.fscan_id && b.fscan_id) return 1;
                  if (a.fscan_id && b.fscan_id) return a.fscan_id.localeCompare(b.fscan_id);
                  return 0;
                });

                let kongData = arr.filter(item => item.kongName);
                let userData = arr.filter(item => !item.kongName);

                userData.sort((a, b) => a.cont_to_id - b.cont_to_id);

                let sortedArr = [];

                kongData.forEach(kong => {
                  sortedArr.push(kong);
                  userData.forEach(user => {
                    if (user.cont_to_id === kong.orgID) {
                      sortedArr.push(user);
                    }
                  });
                });
                setThPlusTd(sortedArr)
              } else if (item?.entry_exit_status === 1){
                setOutData((prev) => [...prev, item]);
              }
            } else {
              if (item?.entry_exit_status !== 1){
                arr.push(item)

                let kongData = arr.filter(item => item.kongName);
                let userData = arr.filter(item => !item.kongName);

                userData.sort((a, b) => a.cont_to_id - b.cont_to_id);

                let sortedArr = [];

                kongData.forEach(kong => {
                  sortedArr.push(kong);
                  userData.forEach(user => {
                    if (user.cont_to_id === kong.orgID) {
                      sortedArr.push(user);
                    }
                  });
                });
                setThPlusTd(sortedArr)
              } else if (item?.entry_exit_status === 1){
                setOutData((prev) => [...prev, item]);
              }
            }
          }
          if (searchData?.reportType === "2") {
            if (item?.groupData && item?.groupData.length !== 0) {
              if (
                item?.groupData?.find((item) => item?.entry_exit_status === 0)
              ) {
                setThPlusTd((prev) => [...prev, item]);
                item?.groupData &&
                  item?.groupData?.map((item2) => {
                    if (item2?.entry_exit_status === 0)
                      setThPlusTd((prev) => [...prev, item2]);
                    else if (item2?.entry_exit_status === 1)
                      setOutData((prev) => [...prev, item2]);
                  });
              }
            }
          }
          if (searchData?.reportType === "4") {
            if (item?.groupData && item?.groupData.length !== 0) {
              // if (item?.groupData?.find((item) => item?.entry_exit_status !== 1))
              setThPlusTd((prev) => [...prev, item]);
              item?.groupData &&
                item?.groupData?.map((item2) => {
                  if (item2?.entry_exit_status === 0)
                    setThPlusTd((prev) => [...prev, item2]);
                  else if (item2?.entry_exit_status === 1)
                    setOutData((prev) => [...prev, item2]);
                });
            }
          }
          if (searchData?.reportType === "5") {
            if (item?.groupData && item?.groupData.length !== 0) {
              if (
                item?.groupData?.find(
                  (item) =>
                    (item?.entry_exit_status !== 3 &&
                      item?.entry_exit_status !== 1 &&
                      item?.entry_exit_status !== 0) ||
                    (item?.entry_exit_status === 0 && item?.workingours < 8)
                )
              )
                setThPlusTd((prev) => [...prev, item]);
              item?.groupData &&
                item?.groupData?.map((item2) => {
                  if (
                    (item2?.entry_exit_status !== 3 &&
                      item2?.entry_exit_status !== 1 &&
                      item2?.entry_exit_status !== 0) ||
                    (item2?.entry_exit_status === 0 && item2?.workingours < 8)
                  )
                    setThPlusTd((prev) => [...prev, item2]);
                  else if (item2?.entry_exit_status === 1)
                    setOutData((prev) => [...prev, item2]);
                });
            }
          }
          
        })
    } else {
      if (searchData?.org_id_lv_2 === "" && searchData?.org_id_lv_3 === "" && searchData?.user_id === "") {
          orgInnerKong?.map(x => {
            if (x.child?.length > 0) {
              x.child?.map(y =>{
                let filTerGroup = employeeAll.filter(z => z.cont_to_id === y.org_id)
                if (employeeAll.filter(z => z.cont_to_id === y.org_id).length > 0) {
                  arr.push({kongName: x.org_name, groupName: y.org_name})
                  arr.push(filTerGroup)
                }
              })
            } else {
                let filTerGroup = employeeAll.filter(z => z.cont_to_id === x.org_id)
                if (employeeAll.filter(z => z.cont_to_id === x.org_id).length > 0) {
                  arr.push({kongName: x.org_name, groupName: ""})
                  arr.push(filTerGroup)
                }
            }
          })
          arr = arr.flat()
          setThPlusTd(arr)
      } else if (searchData?.user_id !== "") {
            arr.push(
              {
                kongName: orgInnerKong.find( y => y.org_id == searchData?.org_id_lv_2)?.org_name, 
                groupName: orgInnerKong.find( y => y.org_id == searchData?.org_id_lv_2)?.child?.find( groupOrg => groupOrg.org_id == searchData?.org_id_lv_3)?.org_name
              }
            )
            arr.push(employeeAll?.find( x => x.user_id == searchData?.user_id))
            setThPlusTd(arr)
      } else if (searchData?.org_id_lv_3 !== "") {
            let emData
              emData = [{
                kongName: orgInnerKong.find( y => y.org_id == searchData?.org_id_lv_2)?.org_name, 
                groupName: orgInnerKong.find( y => y.org_id == searchData?.org_id_lv_2)?.child?.find( groupOrg => groupOrg.org_id == searchData?.org_id_lv_3)?.org_name
              }]
              employeeAll.forEach(element => { emData.push(element) });
              setThPlusTd(emData)

      } else if (searchData?.org_id_lv_2 !== "") {
          // if (orgInnerKong.find( y => y.org_id == searchData?.org_id_lv_2)?.child.length > 0) {
          //   for (let index = 0; index < orgInnerKong.find( y => y.org_id == searchData?.org_id_lv_2)?.child.length; index++) {
          //     const element = orgInnerKong.find( y => y.org_id == searchData?.org_id_lv_2)?.child[index];
          //     if (employeeAll?.filter(filEm => filEm.cont_to_id ==  element?.org_id)?.length > 0) {
          //       arr.push({kongName: orgInnerKong.find( y => y.org_id == searchData?.org_id_lv_2)?.org_name, groupName: element?.org_name})
          //       arr.push(employeeAll?.filter(filEm => filEm.cont_to_id ==  element?.org_id))
          //       arr = arr?.flat()
          //     }
          //   }
          // } else {
          //     arr.push({kongName: orgInnerKong.find( y => y.org_id == searchData?.org_id_lv_2)?.org_name, groupName: ""})
          //     arr.push(employeeAll?.filter(filEm => filEm.cont_to_id ==  orgInnerKong.find( y => y.org_id == searchData?.org_id_lv_2)?.org_id))
          //     arr = arr?.flat()
          // }

          let seen = new Set();
          let uniqueArray = arr.filter((items, index) => {
            let key = JSON.stringify(items); 
            return seen.has(key) ? false : seen.add(key);
          });
          setThPlusTd(uniqueArray)

      }
    }
    setTimeout(() => {
      setLoadingRep(true);
    }, 5000);
    toggle(); 
  }

  // useEffect(() => {
  //   console.log(chunkThTd, searchData)

  // }, [chunkThTd])
  

  return (
    <FadeIn>
      <SubMenuEntryWork menu={1}/>
      <Breadcrumb
        title="หน้าหลัก"
        breadcrumbItem="ลงเวลาปฏิบัติราชการ"
        isBack={true}
        isSubMenu={true}
        subMenuName="ค้นหารายงาน"
        path="/entrywork"
      />
      <Row>
          <Col xxl={3}>
            <Card>
              {loading 
                ? 
                  <Lottie
                    options={{
                      loop: true,
                      autoplay: true,
                      animationData: loadingLeaveTap.default,
                      rendererSettings: {
                        preserveAspectRatio: "xMidYMid slice",
                      },
                    }}
                    width={250}
                    height={250}
                  /> 
                :
                <CardBody style={{}} className="pb-1">
                  <CardTitle>
                    <h4>ค้นหารายงาน</h4>
                  </CardTitle>
                  <Form
                    className="mt-4"
                    onSubmit={(e) => {
                      e.preventDefault();
                      // handleFindReport();
                      if (searchData?.reportType !== "6") {
                        // getSearchEntry();
                        getSearchEntryNew()
                      } else if (searchData?.reportType === "6") {
                        getLeaveBeforeTime();
                      }
                    }}
                  >
                    <FormGroup row>
                      <Label className="text-end" xxl={4} xs={4}>
                        เริ่มวันที่
                      </Label>
                      <Col>
                        <NewThaiDatePicker value={searchData?.dmy_start}
                          // maxDate={searchData?.dmy_end}
                          setValue={setDateStart} placeholderText = "วัน/เดือน/ปี" showClearButton = {true} invalidProps={!searchData?.dmy_start}/>
                      </Col>
                    </FormGroup>
                    <FormGroup row>
                      <Label className="text-end" xxl={4} xs={4}>
                        ถึงวันที่
                      </Label>
                      <Col>
                      <NewThaiDatePicker invalidProps={!searchData?.dmy_end} value={searchData?.dmy_end} minDate={searchData?.dmy_start} setValue={setDateEnd} placeholderText = "วัน/เดือน/ปี" showClearButton = {true}/>
                      </Col>
                    </FormGroup>
                    {((CheckSubAdmin(userInfo?.positionSubAdmin).length > 0 && 
                      (CheckSubAdmin(userInfo?.positionSubAdmin).includes(0) || 
                      CheckSubAdmin(userInfo?.positionSubAdmin).includes(2))) ||
                      (positionFromInfo &&
                        positionFromInfo?.some((a) => a?.position_id === 5 || a?.position_id === 7 || a?.position_id === 3))) && (

                          // needAlluser true ต้องส่ง setUserOrgObj เป็นฟังก์ชันรับสองพารามิเตอร์
                          <SelectOrg setDivisionOrg={setDivisionOrgObj} setGroupOrg={setGroupOrgObj} setUserOrg={setUserOrgObj} task="have option" sizeXs = {12} sizeMd = {12} sizeXl = {12} notAdAll={false} functionCheck = {undefined} needAlluser={needAllUser} requiredCondition = {false}/>
                        )}
                 
                    <FormGroup row className="d-flex align-items-center">
                      <Col xxl={12}>
                        <Row className="d-flex align-items-center">
                          <Label className="text-end" xxl={4} xs={4}>
                            ประเภทไฟล์
                          </Label>
                          <Col xxl={1} xs={1}>
                            <Input
                              name="typeFile"
                              className="border border-secondary border-1 border-opacity-75"
                              style={{
                                fontSize: "20px",
                                marginTop: "auto",
                                marginBottom: "auto",
                              }}
                              value="1"
                              defaultChecked={searchData.fileType === "1"}
                              type="radio"
                              onChange={(e) => {
                                setSearchData((prev) => ({
                                  ...prev,
                                  fileType: "1",
                                }));
                              }}
                            />
                          </Col>
                          <Label xxl={3} xs={3}>
                            PDF
                          </Label>
                        </Row>
                      </Col>
                      <Col xxl={12}>
                        <Row className="d-flex align-items-center">
                          <Col xxl={4} xs={4}></Col>
                          <Col xxl={1} xs={1}>
                            <Input
                              name="typeFile"
                              className="border border-secondary border-1 border-opacity-75"
                              style={{
                                fontSize: "20px",
                                marginTop: "auto",
                                marginBottom: "auto",
                              }}
                              value="2"
                              defaultChecked={searchData.fileType === "2"}
                              type="radio"
                              onChange={(e) => {
                                setSearchData((prev) => ({
                                  ...prev,
                                  fileType: "2",
                                }));
                              }}
                            />
                          </Col>
                          <Label xxl={2} xs={2}>
                            CSV
                          </Label>
                        </Row>
                      </Col>
                    </FormGroup>
                    <FormGroup row>
                      <Col xxl={12}>
                        <Row>
                          <Label className="text-end" xxl={5} md={4} sm={4} xs={5}>
                            ประเภทรายงาน
                          </Label>
                        </Row>
                      </Col>
                      <Col xxl={12}>
                        <Row className="d-flex align-items-center">
                          <Col xxl={3} xs={3}></Col>
                          <Col xxl={1} xs={1}>
                            <Input
                              name="typeReport"
                              type="radio"
                              className="border border-secondary border-1 border-opacity-75"
                              style={{
                                fontSize: "20px",
                                marginTop: "auto",
                                marginBottom: "auto",
                              }}
                              value="1"
                              defaultChecked={searchData.reportType === "1"}
                              onChange={(e) => {
                                setSearchData((prev) => ({
                                  ...prev,
                                  reportType: "1",
                                }));
                              }}
                            />
                          </Col>
                          <Label xxl={6} xs={6}>
                            การลงเวลาปฎิบัติงาน
                          </Label>
                        </Row>
                      </Col>
                      <Col xxl={12}>
                        <Row style={{ display: "flex", alignItems: "center" }}>
                          <Col xxl={3} xs={3}></Col>
                          <Col xxl={1} xs={1}>
                            <Input
                              name="typeReport"
                              type="radio"
                              className="border border-secondary border-1 border-opacity-75"
                              style={{
                                fontSize: "20px",
                                marginTop: "auto",
                                marginBottom: "auto",
                              }}
                              value="2"
                              defaultChecked={searchData.reportType === "2"}
                              onChange={(e) => {
                                setSearchData((prev) => ({
                                  ...prev,
                                  reportType: "2",
                                }));
                              }}
                            />
                          </Col>
                          <Label xxl={6} xs={6}>
                            การเข้างานสาย
                          </Label>
                        </Row>
                      </Col>
                      {/* <Col xxl={12}>
                        <Row style={{ display: "flex", alignItems: "center" }}>
                          <Col xxl={3} xs={3}></Col>
                          <Col xxl={1} xs={1}>
                            <Input
                              name="typeReport"
                              type="radio"
                              className="border border-secondary border-1 border-opacity-75"
                              style={{
                                fontSize: "20px",
                                marginTop: "auto",
                                marginBottom: "auto",
                              }}
                              value="3"
                              defaultChecked={searchData.reportType === "3"}
                              onChange={(e) => {
                                setSearchData((prev) => ({
                                  ...prev,
                                  reportType: "3",
                                }));
                              }}
                            />
                          </Col>
                          <Label xxl={6} xs={6}>
                            การไม่มาปฏิบัติราชการ
                          </Label>
                        </Row>
                      </Col> */}
                      <Col xxl={12}>
                        <Row style={{ display: "flex", alignItems: "center" }}>
                          <Col xxl={3} xs={3}></Col>
                          <Col xxl={1} xs={1}>
                            <Input
                              name="typeReport"
                              type="radio"
                              className="border border-secondary border-1 border-opacity-75"
                              style={{
                                fontSize: "20px",
                                marginTop: "auto",
                                marginBottom: "auto",
                              }}
                              value="4"
                              defaultChecked={searchData.reportType === "4"}
                              onChange={(e) => {
                                setSearchData((prev) => ({
                                  ...prev,
                                  reportType: "4",
                                }));
                              }}
                            />
                          </Col>
                          <Label xxl={6} xs={6}>
                            การทำงานล่วงเวลา
                          </Label>
                        </Row>
                      </Col>
                      <Col xxl={12}>
                        <Row className="d-flex align-items-center">
                          <Col xxl={3} xs={3}></Col>
                          <Col xxl={1} xs={1}>
                            <Input
                              name="typeReport"
                              type="radio"
                              className="border border-secondary border-1 border-opacity-75"
                              style={{
                                fontSize: "20px",
                                marginTop: "auto",
                                marginBottom: "auto",
                              }}
                              value="5"
                              defaultChecked={searchData.reportType === "5"}
                              onChange={(e) => {
                                setSearchData((prev) => ({
                                  ...prev,
                                  reportType: "5",
                                }));
                              }}
                            />
                          </Col>
                          <Label xxl={6} xs={6}>
                            ไม่ครบตามรอบเวลา
                          </Label>
                        </Row>
                      </Col>
                      <Col xxl={12}>
                        <Row className="d-flex align-items-center">
                          <Col xxl={3} xs={3}></Col>
                          <Col xxl={1} xs={1}>
                            <Input
                              name="typeReport"
                              type="radio"
                              className="border border-secondary border-1 border-opacity-75"
                              style={{
                                fontSize: "20px",
                                marginTop: "auto",
                                marginBottom: "auto",
                              }}
                              value="6"
                              defaultChecked={searchData.reportType === "6"}
                              onChange={(e) => {
                                setSearchData((prev) => ({
                                  ...prev,
                                  reportType: "6",
                                }));
                              }}
                            />
                          </Col>
                          <Label xxl={6} xs={6}>
                            ขออนุญาตกลับก่อน
                          </Label>
                        </Row>
                      </Col>
                    </FormGroup>
                    <FormGroup
                      row
                      style={{ display: "flex", justifyContent: "end" }}
                    >
                      <Col xl={6} className="d-flex justify-content-center">
                        <Button
                          onClick={() => {
                            handleResetSearch();
                          }}
                          className="w-100"
                          color="warning"
                        >
                          ล้างการค้นหา
                        </Button>
                      </Col>
                      <Col className="d-flex justify-content-center">
                        <Button disabled={!searchData?.dmy_end || !searchData?.dmy_start} 
                            type="submit"
                            className={
                                `${windowSize.width < 576 
                                || (windowSize.width >= 576 && windowSize.width < 992 ) 
                                || (windowSize.width >= 992 && windowSize.width < 1200 )
                                  ? "w-100 mt-2" 
                                  : "w-100"
                                }
                            `} 
                          color="success">
                          ค้นหารายงาน
                        </Button>
                      </Col>
                    </FormGroup>
                  </Form>
                </CardBody>
              }
            </Card>
          </Col>
          <Col xxl={9}>
            <Card style={{ minHeight: "680px" }}>
              <CardBody>
                <Row>
                  <Col xxl={12} className="d-flex justify-content-center">
                    <CardTitle>
                      <h3>ตัวอย่างรายงาน</h3>
                    </CardTitle>
                  </Col>
                  <Col
                    style={{ minHeight: "400px" }}
                    className="d-flex align-items-center justify-content-center"
                  >
                    {!showReport && (
                      <h5 className="text-muted text-center">
                        โปรดใส่วันที่ ประเภทของรายงาน และกดปุ่ม "ค้นหารายงาน"
                        เพื่อค้นหารายงานที่ต้องการ
                      </h5>
                    )}
                  </Col>
                </Row>
              </CardBody>
            </Card>
          </Col>
      </Row>
      <Modal
        style={{ minWidth: "80vw" }}
        centered
        isOpen={modal}
        toggle={toggle}
      >
        <ModalHeader toggle={toggle}></ModalHeader>
        <ModalBody style={{overflow: "scroll"}}>
          <div ref={pdfRef} style={{minWidth:"1106px"}}>
            {!loadingRep && (
              <div>
                <Lottie
                  options={{
                    loop: true,
                    autoplay: true,
                    animationData: loadingReport.default,
                    rendererSettings: {
                      preserveAspectRatio: "xMidYMid slice",
                    },
                  }}
                  width={200}
                  height={200}
                />
              </div>
            )}

            {/* {Array.from({ length: chunkThTdPage }, (_, index) => { */}
            {loadingRep && (
              <>
                {
                  chunkThTd &&
                    chunkThTd.length !== 0 ?
                    chunkThTd?.map((item, idx) => {
                      return (
                        <React.Fragment key={`idx_of_${idx}`}>
                          <div
                            className="container-fluid p-2 px-3"
                            style={{
                              fontFamily: "Sarabun,serif",
                              fontSize: "16px",
                            }}
                          >
                            <Row
                              className="d-flex border border-1 border-dark mx-0"
                              style={{ alignItems: "center" }}
                            >
                              <Col
                                className="d-flex justify-content-center"
                                xxl={12}
                              >
                                <strong className="font-size-20">
                                  รายงาน
                                  {searchData?.reportType === "1"
                                    ? "การลงเวลาปฎิบัติงาน"
                                    : searchData?.reportType === "2"
                                    ? "การเข้างานสาย"
                                    : // : searchData?.reportType === "3"
                                    // ? "การไม่มาปฏิบัติราชการ"
                                    searchData?.reportType === "4"
                                    ? "การทำงานล่วงเวลา"
                                    : searchData?.reportType === "5"
                                    ? "ไม่ครบตามรอบเวลา"
                                    : searchData?.reportType === "6"
                                    ? "ขออนุญาตกลับก่อน"
                                    : ""}
                                </strong>
                              </Col>
                            </Row>
                            <Row className="mt-2">
                              <Col xxl={8}>
                                <b className="font-size-16">
                                  วันที่ :{" "}
                                  {ConvertDate(
                                    searchData?.dmy_start
                                  )?.toThaiDateDMY()}{" "}
                                  ถึง{" "}
                                  {ConvertDate(
                                    searchData?.dmy_end
                                  )?.toThaiDateDMY()}
                                </b>
                              </Col>
                              <Col
                                xxl={4}
                                className="d-flex justify-content-end"
                              >
                                <b className="font-size-16">
                                  หน้าที่ {idx + 1} / {chunkThTdPage}
                                </b>
                              </Col>
                            </Row>
                            <Row>
                              <Col xxl={12}>
                                <table style={{ width: "100%" }} className="table table-striped">
                                  <thead className="text-nowrap text-center">
                                    <tr
                                      style={{
                                        fontWeight: "bold",
                                      }}
                                      className="border-bottom border-dark"
                                    >
                                      <th width="9%" className="text-center">
                                        วันที่
                                      </th>
                                      {/* {searchData?.reportType !== "6" && (
                                        <th width="6%" className="text-center">
                                          รอบเข้างาน
                                        </th>
                                      )} */}
                                      <th>ชื่อ-นามสกุล</th>
                                      {(searchData?.reportType === "1" ||
                                        searchData?.reportType === "2" ||
                                        searchData?.reportType === "4" ||
                                        searchData?.reportType === "5") && (
                                        <>
                                          <th
                                            className="text-center"
                                            width="8%"
                                          >
                                            เวลาเข้า
                                          </th>
                                          <th
                                            className="text-center"
                                            width="8%"
                                          >
                                            เวลาออก
                                          </th>
                                        </>
                                      )}
                                      {(searchData?.reportType === "1" ||
                                        searchData?.reportType === "4" ||
                                        searchData?.reportType === "5") && (
                                        <th className="text-center" width="12%">
                                          จำนวนชั่วโมงทำงาน
                                        </th>
                                      )}
                                      {searchData?.reportType === "2" && (
                                        <th className="text-center">
                                          จำนวนชั่วโมงเข้าสาย
                                        </th>
                                      )}
                                      {searchData?.reportType === "4" && (
                                        <th className="text-center" width="12%">
                                          จำนวนชั่วโมงล่วงเวลา
                                        </th>
                                      )}
                                      {searchData?.reportType === "6" && (
                                        <>
                                          <th
                                            className="text-center"
                                            width="15%"
                                          >
                                            วันที่ขออนุญาตกลับก่อน
                                          </th>
                                          <th
                                            className="text-center"
                                            width="13%"
                                          >
                                            การอนุมัติขั้นต้น
                                          </th>
                                          <th
                                            className="text-center"
                                            width="13%"
                                          >
                                            การอนุมัติ
                                          </th>

                                          <th
                                            className="text-center"
                                            width="25%"
                                          >
                                            เหตุผล
                                          </th>
                                        </>
                                      )}
                                      {(searchData?.reportType === "1" ||
                                        searchData?.reportType === "2" ||
                                        searchData?.reportType === "5") && (
                                        <th width="18%" className="text-center">
                                          สถานะ
                                        </th>
                                      )}
                                      {searchData?.reportType === "4" && (
                                        <th className="text-center" width="10%">
                                          ค่าล่วงเวลา
                                        </th>
                                      )}
                                      {searchData?.reportType === "4" && (
                                        <th className="text-center" width="12%">
                                          หมายเหตุ
                                        </th>
                                      )}
                                    </tr>
                                  </thead>
                                  {loadingReports ?
                                    <tbody>
                                      <tr>
                                        <td className="text-center" colSpan={7}>
                                          <LoadingData/> 
                                        </td>
                                      </tr>
                                    </tbody>
                                  :
                                    <tbody>
                                      {item &&
                                        item?.sort((a, b) => new Date(a?.date) - new Date(b?.date))?.map((item2, idx) => {
                                          let orgKongName = orgInnerKong?.find(
                                            (item) =>
                                              parseInt(item?.org_id) ===
                                              parseInt(searchData?.org_id_lv_2)
                                          );
                                          let prefixName = "";
                                          let firstName = "";
                                          let middleName = "";
                                          let lastName = "";
                                          let other = "";
                                          let nameSplitLength = 0;

                                          if (!item2?.hasOwnProperty("org_id")) {
                                            nameSplitLength = item2?.user_name?.split(" ")?.length;
                                            // if (nameSplitLength === undefined) {
                                            //   console.log(item2)
                                            // }
                                            if (item2?.user_name?.split(" ")?.length === 2
                                            ) {
                                              prefixName = item2?.user_title_name;
                                              firstName =
                                                item2?.user_name?.split(" ")[0];
                                              lastName =
                                                item2?.user_name?.split(" ")[1];
                                            } else if (
                                              item2?.user_name?.split(" ")
                                                ?.length === 3
                                            ) {
                                              prefixName = item2?.user_title_name;
                                              firstName =
                                                item2?.user_name?.split(" ")[0];
                                              middleName =
                                                item2?.user_name?.split(" ")[1];
                                              lastName =
                                                item2?.user_name?.split(" ")[2];
                                            } else if (
                                              item2?.user_name?.split(" ")
                                                ?.length === 1
                                            ) {
                                              prefixName = item2?.user_title_name;
                                              firstName =
                                                item2?.user_name?.split(" ")[0];
                                              middleName =
                                                item2?.user_name?.split(" ")[1];
                                              lastName =
                                                item2?.user_name?.split(" ")[2];
                                            } else if (
                                              item2?.user_name?.split(" ")
                                                ?.length === 4
                                            ) {
                                              prefixName = item2?.user_title_name;
                                              firstName =
                                                item2?.user_name?.split(" ")[0];
                                              middleName =
                                                item2?.user_name?.split(" ")[1];
                                              lastName =
                                                item2?.user_name?.split(" ")[2];
                                              other =
                                                item2?.user_name?.split(" ")[3];
                                            } else {
                                              prefixName = "";
                                              firstName = "";
                                              middleName = "";
                                              lastName = "";
                                            }
                                          } else {
                                          }

                                          let timeInSlice = item2?.scan_date
                                            ?.split("T")[1]
                                            ?.split(".")[0];

                                          let match = outData?.find(
                                            (find) =>
                                              find?.date === item2?.date &&
                                              find?.user_id === item2?.user_id
                                          );
                                          let timeOutSlice;
                                          let DeviceOut;

                                          let workingHours;
                                          let workingMinutes;

                                          let lateHours;
                                          let lateMinutes;

                                          if (item2?.late) {
                                            lateHours =
                                              item2?.late_hours?.split(":")[0];
                                            lateMinutes =
                                              item2?.late_hours?.split(":")[1];
                                          }

                                          let OTHours;
                                          let OTMinutes;
                                          let OTMoneys;
                                          let note;

                                          if (match && match?.length !== 0) {
                                            timeOutSlice = match?.scan_date
                                              ?.split("T")[1]
                                              ?.split(".")[0];
                                            DeviceOut = match?.from_device;
                                            workingHours =
                                              match?.working_hours?.split(":")[0];
                                            workingMinutes =
                                              match?.working_hours?.split(":")[1];
                                            if ( parseInt(match?.working_hours?.split(":")[0]) > 8) {
                                              OTHours = parseInt(match?.working_hours?.split(":")[0]) - 8;
                                              OTMinutes = parseInt(match?.working_hours?.split(":")[1]);
                                              OTMoneys = (parseInt(match?.working_hours?.split(":")[0]) - 8) * 50;
                                            }
                                            note = match?.note;
                                          } else if (item2?.note !== "-") {
                                            note = item2?.note;
                                          } else {
                                            note = item2?.entry_exit_status_name;
                                          }
                                          return (
                                            <React.Fragment key={`idx_of_idx_${idx}`}>
                                              {(item2 &&
                                                item2?.hasOwnProperty(
                                                  "org_id"
                                                )) ||
                                              item2?.hasOwnProperty(
                                                "kongName"
                                              ) ? (
                                                <tr>
                                                  <td></td>
                                                  <td></td>
                                                  <td
                                                    className="py-2"
                                                    colSpan={searchData?.reportType === "4" ? 4 : 3}
                                                  >
                                                    <strong>
                                                      {item2?.hasOwnProperty(
                                                        "org_id"
                                                      )
                                                        ? parseInt(
                                                            searchData?.org_id_lv_2
                                                          ) ===
                                                          parseInt(item2?.org_id)
                                                          ? orgKongName?.org_name
                                                          : orgKongName?.org_name +
                                                            " : " +
                                                            item2?.org_name
                                                        : null}
                                                      {item2?.hasOwnProperty(
                                                        "kongName"
                                                      ) &&
                                                        item2?.kongName +
                                                          " : " +
                                                          item2?.groupName}
                                                    </strong>
                                                  </td>
                                                  <td></td>
                                                  <td></td>
                                                </tr>
                                              ) : (
                                                <tr>
                                                  <td style={{whiteSpace: "nowrap"}} className="text-center py-1">
                                                    {searchData?.reportType ===
                                                    "6"
                                                      ? ConvertDate(
                                                          item2?.leave_from_date
                                                        )?.toThaiDateDMY()
                                                      : ConvertDate(
                                                          item2?.date
                                                        )?.toThaiDateDMY()}
                                                  </td>
                                                  {/* {searchData?.reportType !==
                                                    "6" && (
                                                    <td className="text-center py-1">
                                                      {
                                                        item2?.user_start_work_name
                                                      } 
                                                    </td>
                                                  )} */}
                                                  <td>
                                                    &nbsp;&nbsp;
                                                    {nameSplitLength === 3 ? (
                                                      <>
                                                        {" "}
                                                        {prefixName}
                                                        {firstName}
                                                        &nbsp;&nbsp;
                                                        {middleName}
                                                        &nbsp;&nbsp;
                                                        {lastName}
                                                      </>
                                                    ) : nameSplitLength === 2 ? (
                                                      <>
                                                        {" "}
                                                        {prefixName}
                                                        {firstName}
                                                        &nbsp;&nbsp;
                                                        {lastName}
                                                      </>
                                                    ) : nameSplitLength === 4 ? (
                                                      <>
                                                        {" "}
                                                        {prefixName}
                                                        {firstName}
                                                        &nbsp;&nbsp;
                                                        {middleName}
                                                        &nbsp;&nbsp;
                                                        {lastName}
                                                        {other}
                                                      </>
                                                    ) : (
                                                      // item2?.created_user
                                                      item2?.user_name
                                                    )}
                                                  </td>
                                                  {(searchData?.reportType ===
                                                    "1" ||
                                                    searchData?.reportType ===
                                                      "2" ||
                                                    searchData?.reportType ===
                                                      "4" ||
                                                    searchData?.reportType ===
                                                      "5") && (
                                                    <>
                                                      <td className="text-center">
                                                        {item2?.entry_exit_status ===
                                                        0 || item2?.entry_exit_status ===
                                                        5
                                                          ? `${timeInSlice}`
                                                          : // ${item2?.from_device}

                                                            ""}
                                                      </td>
                                                      <td className="text-center">
                                                        {timeOutSlice 
                                                        // && DeviceOut
                                                          ? `${timeOutSlice}`
                                                          : // ${DeviceOut}
                                                            ""}
                                                      </td>
                                                    </>
                                                  )}

                                                  {searchData?.reportType ===
                                                    "6" && (
                                                    <>
                                                      <td className="text-center">
                                                        {ConvertDate(
                                                          item2?.write_date
                                                        )?.toThaiDateDMY()}
                                                      </td>
                                                      {item2?.leave_status &&
                                                      (item2?.leave_status === "5" || item2?.leave_status === "0") ?
                                                      (
                                                        <>
                                                          <td className="text-center">
                                                            ได้รับการอนุมัติ
                                                          </td>
                                                          <td className="text-center">
                                                            ได้รับการอนุมัติ
                                                          </td>
                                                        </>
                                                      ) : item2?.leave_status &&
                                                        item2?.leave_status ===
                                                          "3" ? (
                                                        <>
                                                          <td className="text-center">
                                                            ได้รับการอนุมัติ
                                                          </td>
                                                          <td className="text-center"></td>
                                                        </>
                                                      ) : item2?.leave_status &&
                                                        item2?.leave_status ===
                                                          "4" ? (
                                                        <>
                                                          <td className="text-center"></td>
                                                          <td className="text-center"></td>
                                                        </>
                                                      ) : null}
                                                      <td className="text-center">
                                                        {item2?.leave_reason}
                                                      </td>
                                                    </>
                                                  )}

                                                  {(searchData?.reportType ===
                                                    "1" ||
                                                    searchData?.reportType ===
                                                      "4" ||
                                                    searchData?.reportType ===
                                                      "5") && (
                                                    <td className="text-center">
                                                      {match && match.length !== 0
                                                        ? `${
                                                            workingHours
                                                              ? workingHours
                                                              : 0
                                                          } ชั่วโมง ${
                                                            workingMinutes
                                                              ? workingMinutes
                                                              : 0
                                                          } นาที`
                                                        : ""}
                                                    </td>
                                                  )}
                                                  {searchData?.reportType ===
                                                    "2" && (
                                                    <td className="text-center">
                                                      {item2?.late
                                                        ? `${
                                                            lateHours
                                                              ? lateHours
                                                              : 0
                                                          } ชั่วโมง ${
                                                            lateMinutes
                                                              ? lateMinutes
                                                              : 0
                                                          } นาที`
                                                        : `0 ชั่วโมง 0 นาที`}
                                                    </td>
                                                  )}
                                                  {searchData?.reportType ===
                                                    "4" && (
                                                    <td className="text-center">
                                                      {match && match.length !== 0
                                                        ? `${
                                                            OTHours ? OTHours : 0
                                                          } ชั่วโมง ${
                                                            OTMinutes
                                                              ? OTMinutes
                                                              : 0
                                                          } นาที`
                                                        : ""}
                                                    </td>
                                                  )}
                                                  {searchData?.reportType ===
                                                    "6" && (
                                                    <td className="text-center"></td>
                                                  )}
                                                  {(searchData?.reportType ===
                                                    "1" ||
                                                    searchData?.reportType ===
                                                      "2" ||
                                                    searchData?.reportType ===
                                                      "5") && (
                                                    <td className="text-center">
                                                      {/* { note ?? ""} */}
                                                      {searchData?.reportType ===
                                                      "2" ? (item2?.late === 2  ? "สายช่วงเช้า" : item2?.late === 3 ? "สายช่วงบ่าย" : note ?? "")  : note ?? ""}
                                                    </td>
                                                  )}
                                                  {searchData?.reportType ===
                                                    "4" && (
                                                    <td className="text-center">
                                                      {OTMoneys
                                                        ? `${OTMoneys >= 200 ? 200 : OTMoneys} บาท`
                                                        : "-"}
                                                    </td>
                                                  )}
                                                  {searchData?.reportType ===
                                                    "4" && (
                                                    <td className="text-center">
                                                      {match?.ot_remark ?? "-"}
                                                    </td>
                                                  )}
                                                </tr>
                                              )}
                                            </React.Fragment>
                                          );
                                        })}
                                    </tbody>
                                  }
                                  
                                </table>
                              </Col>
                            </Row>
                          </div>
                        </React.Fragment>
                      );
                    })
                  : (
                    <React.Fragment>
                      <div
                        className="container-fluid p-2 px-3"
                        style={{
                          fontFamily: "Sarabun,serif",
                          fontSize: "16px",
                        }}
                      >
                        <Row
                          className="d-flex border border-1 border-dark mx-0"
                          style={{ alignItems: "center" }}
                        >
                          <Col className="d-flex justify-content-center" xxl={12}>
                            <strong className="font-size-20">
                              รายงาน
                              {searchData?.reportType === "1"
                                ? "การลงเวลาปฎิบัติงาน"
                                : searchData?.reportType === "2"
                                ? "การเข้างานสาย"
                                : // : searchData?.reportType === "3"
                                // ? "การไม่มาปฏิบัติราชการ"
                                searchData?.reportType === "4"
                                ? "การทำงานล่วงเวลา"
                                : searchData?.reportType === "5"
                                ? "ไม่ครบตามรอบเวลา"
                                : searchData?.reportType === "6"
                                ? "ขออนุญาตกลับก่อน"
                                : ""}
                            </strong>
                          </Col>
                        </Row>
                        <Row className="mt-2">
                          <Col xxl={8}>
                            <b className="font-size-16">
                              วันที่ :{" "}
                              {ConvertDate(
                                searchData?.dmy_start
                              )?.toThaiDateDMY()}{" "}
                              ถึง{" "}
                              {ConvertDate(searchData?.dmy_end)?.toThaiDateDMY()}
                            </b>
                          </Col>
                          <Col xxl={4} className="d-flex justify-content-end">
                            <b className="font-size-16">
                              หน้าที่
                              {/* {idx + 1} / {chunkThTdPage} */}
                            </b>
                          </Col>
                        </Row>
                        <Row>
                          <Col xxl={12}>
                            <table style={{ width: "100%" }}>
                              <thead className="text-nowrap text-center">
                                <tr
                                  style={{
                                    fontWeight: "bold",
                                  }}
                                  className="border-bottom border-dark"
                                >
                                  <th width="10%" className="text-center">
                                    วันที่
                                  </th>
                                  {/* {searchData?.reportType !== "6" && (
                                    <th className="text-center">รอบเข้างาน</th>
                                  )} */}
                                  <th width="30%">ชื่อ-นามสกุล</th>
                                  {(searchData?.reportType === "1" ||
                                    searchData?.reportType === "2" ||
                                    searchData?.reportType === "4" ||
                                    searchData?.reportType === "5") && (
                                    <>
                                      <th className="text-center" width="12%">
                                        เวลาเข้า
                                      </th>
                                      <th className="text-center" width="12%">
                                        เวลาออก
                                      </th>
                                    </>
                                  )}
                                  {(searchData?.reportType === "1" ||
                                    searchData?.reportType === "4" ||
                                    searchData?.reportType === "5") && (
                                    <th className="text-center" width="12%">
                                      จำนวนชั่วโมงทำงาน
                                    </th>
                                  )}
                                  {searchData?.reportType === "2" && (
                                    <th className="text-center">
                                      จำนวนชั่วโมงเข้าสาย
                                    </th>
                                  )}
                                  {searchData?.reportType === "4" && (
                                    <th className="text-center" width="12%">
                                      จำนวนชั่วโมงล่วงเวลา
                                    </th>
                                  )}
                                  {searchData?.reportType === "6" && (
                                    <>
                                      <th className="text-center" width="15%">
                                        วันที่ขออนุญาตกลับก่อน
                                      </th>
                                      <th className="text-center" width="13%">
                                        การอนุมัติขั้นต้น
                                      </th>
                                      <th className="text-center" width="13%">
                                        การอนุมัติ
                                      </th>

                                      <th className="text-center" width="25%">
                                        เหตุผล
                                      </th>
                                    </>
                                  )}
                                  {(searchData?.reportType === "1" ||
                                    searchData?.reportType === "2" ||
                                    searchData?.reportType === "5") && (
                                    <th width="10%">สถานะ</th>
                                  )}
                                  {searchData?.reportType === "4" && (
                                    <th className="text-center" width="10%">
                                      ค่าล่วงเวลา
                                    </th>
                                  )}
                                  {searchData?.reportType === "4" && (
                                    <th className="text-center" width="10%">
                                      หมายเหตุ
                                    </th>
                                  )}
                                </tr>
                              </thead>
                            </table>
                          </Col>
                        </Row>
                      </div>
                    </React.Fragment>
                  )
                }
              </>
            )}
            {/* })} */}
          </div>
          <Row className="mt-4">
            <Col xs={12} md={12} lg={12} xxl={12} className={
                    `${windowSize.width < 576 
                    || (windowSize.width >= 576 && windowSize.width < 992 ) 
                    || (windowSize.width >= 992 && windowSize.width < 1200 )
                      ? "d-flex justify-content-start" 
                      : "d-flex justify-content-end"
                    }
                `}>
              {searchData?.fileType === "1" ? (
                <Button
                  disabled={loadingPDF}
                  color="success"
                  onClick={async () => {
                    await downloadPDF();
                  }}
                >
                  {loadingPDF === true ? (
                    <i className="bx bx-loader bx-spin font-size-16 align-middle me-2"></i>
                  ) : (
                    <i className="fa-solid fa-print pe-2"></i>
                  )}
                  ดาวน์โหลด PDF
                </Button> 
              ) : (
                <ExcelExport
                  // outData={searchData?.reportType !== "6" ? outData : null} loadingPDF
                  // thPlusTd={searchData?.reportType !== "6" ? thPlusTd : null}
                  reportType={searchData?.reportType}
                  excelData={
                    searchData?.reportType !== "6"
                      ? [thPlusTd, outData]
                      : leaveBefore
                  }
                  fileName={selectFileNameByType(searchData?.reportType)}
                />
              )}
            </Col>
          </Row>
        </ModalBody>
      </Modal>
    </FadeIn>
  );
};

export default Menu1;
